import { useWorkspaceText } from './interface-copy';
import { OFFICE_FILE_TYPES } from '../../src/company-workspace/data/business-file-types.mjs';
import { fileReadabilityMessage } from './file-upload';
import type { CompanyFile } from './types';

export function FileReadability({ file }: { file: CompanyFile }) {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  const unavailable = fileReadabilityMessage(file);
  if (unavailable)
    return (
      <p className="ws-page-note" role="status">
        {unavailable}
      </p>
    );
  if (!OFFICE_FILE_TYPES.includes(file.mimeType)) return null;
  return (
    <p className="ws-page-note">
      {uiText(
        'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.',
      )}
    </p>
  );
}
